import { Button, useListContext } from 'react-admin'
import CameraAltIcon from '@mui/icons-material/CameraAlt'
import usePhysicalOrders from '../hooks/usePhysicalOrders'

const BulkSnapshotButton = () => {
  const { openBatchSnapshot } = usePhysicalOrders()
  const { selectedIds } = useListContext()

  const handleClick = () => {
    if (!selectedIds || selectedIds.length === 0) return
    openBatchSnapshot({ batchIds: selectedIds })
  }

  return (
    <Button
      label="Snapshot"
      startIcon={<CameraAltIcon />}
      onClick={handleClick}
      data-testid="bulk-snapshot-button"
    />
  )
}

export default BulkSnapshotButton
